import { Box, Tab, TabList, TabPanel, TabPanels, Tabs } from "@chakra-ui/react";
import { TabPontosEssenciais } from "./TabPontosEssenciais";
import { TabInformativos } from "./TabInformativos";
import { TabManifestacoes } from "./TabManifestacoes";
import { useVerListagem } from "../../contexts/VerListagemProvider";

export function SideMapLista() {
  const { isOpen, setIsOpen } = useVerListagem();

  return (
    <Box
      className="leaflet-control leaflet-bar"
      bgColor="transparent"
      h="70vh"
      w="min(100vw, 360px)"
      overflowY="auto"
      p="0"
      transform={`translateX(${isOpen ? "0" : "-120%"})`}
      transition="transform 0.3s"
    >
      <Tabs
        variant="enclosed-colored"
        colorScheme="main"
        display="flex"
        flexDirection="column"
        h="full"
      >
        <TabList>
          <Tab fontSize="sm" w="full" borderTopLeftRadius="0.5rem">
            Publicações
          </Tab>
          <Tab fontSize="sm" w="full" borderTopRightRadius="0.5rem">
            Manifestações
          </Tab>
        </TabList>

        <TabPanels minHeight="0" display="flex" flexDirection="column" flex={1}>
          <TabPanel
            p="0"
            minHeight="0"
            display="flex"
            flexDirection="column"
            flex={1}
          >
            <Tabs
              variant="solid-rounded"
              colorScheme="main"
              display="flex"
              flexDirection="column"
              h="full"
              borderTopWidth="thin"
              borderTopColor={"gray.100"}
              borderTopStyle="solid"
            >
              <TabList pt="2" py="2" px="2">
                <Tab
                  fontSize="sm"
                  w="full"
                  rounded="md"
                  _selected={{
                    bg: "main.500",
                    color: "white"
                  }}
                  _hover={{
                    color: "white"
                  }}
                >
                  Pontos essenciais
                </Tab>
                <Tab
                  fontSize="sm"
                  w="full"
                  rounded="md"
                  _selected={{
                    bg: "main.500",
                    color: "white"
                  }}
                >
                  Informativos
                </Tab>
              </TabList>

              <TabPanels
                minHeight="0"
                display="flex"
                flexDirection="column"
                flex={1}
                px="2"
              >
                <TabPanel
                  p="0"
                  pt="2"
                  minHeight="0"
                  display="flex"
                  flexDirection="column"
                  flex={1}
                >
                  <TabPontosEssenciais />
                </TabPanel>
                <TabPanel
                  p="0"
                  pt="2"
                  minHeight="0"
                  display="flex"
                  flexDirection="column"
                  flex={1}
                >
                  <TabInformativos />
                </TabPanel>
              </TabPanels>
            </Tabs>
          </TabPanel>
          <TabPanel
            p="0"
            pt="2"
            minHeight="0"
            display="flex"
            flexDirection="column"
            flex={1}
            px="2"
          >
            <TabManifestacoes />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  );
}
